import PageTemplate from "./PageTemplate";
import Simulation from "../simulation";

const HomePage = {

  /**
   * 
   * @param h
   * @returns {*}
   */
  render(h) {
    
    return (
      <PageTemplate>
        <div class="bg-gray-700">
        <div class="container mx-auto lg:px-6">
          <div class="bg-gray-700">

          <Simulation />
  
          </div>
        </div>
      </div>
        
      </PageTemplate>
    );
  }
};



export default HomePage;